import React, { useState } from 'react';
import axios from 'axios';
import { Trash2, Search, AlertTriangle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function DataCleanupCard() {
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (dryRun) => {
    if (!dryRun && !window.confirm(`Permanently delete ${preview?.would_delete?.users || 'all'} test accounts and ${preview?.total_records || 'their'} related records? This cannot be undone.`)) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API}/api/admin/cleanup-test-data?dry_run=${dryRun}`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (dryRun) { setPreview(res.data); setResult(null); }
      else { setResult(res.data); setPreview(null); }
    } catch (e) {
      alert(e.response?.data?.detail || 'Cleanup failed');
    } finally {
      setBusy(false);
    }
  };

  const rows = (preview?.would_delete || result?.deleted || {});

  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="data-cleanup-card">
      <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-1">
        <Trash2 className="h-5 w-5 text-red-500" /> Test Data Cleanup
      </h3>
      <p className="text-sm text-gray-500 mb-4">Remove fake/test accounts (test.com, example.com, QA users) and unclaimed Telegram shell accounts, plus all their jobs, messages, listings and orders — so dashboards show only real numbers.</p>
      <div className="flex gap-2">
        <button
          onClick={() => run(true)}
          disabled={busy}
          className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          data-testid="cleanup-preview-btn"
        >
          <Search className="h-4 w-4" /> {busy ? 'Working...' : 'Preview'}
        </button>
        {preview && (
          <button
            onClick={() => run(false)}
            disabled={busy}
            className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
            data-testid="cleanup-delete-btn"
          >
            <AlertTriangle className="h-4 w-4" /> Delete {preview.would_delete?.users || 0} test accounts
          </button>
        )}
      </div>
      {(preview || result) && (
        <div className="mt-4 text-sm" data-testid="cleanup-report">
          {result && <p className="font-semibold text-emerald-700 mb-2">✓ Cleanup complete — {result.total_records} records removed.</p>}
          {preview && <p className="font-semibold text-gray-700 mb-2">Would remove {preview.total_records} records:</p>}
          <div className="flex flex-wrap gap-1.5">
            {Object.entries(rows).map(([k, v]) => (
              <span key={k} className="px-2 py-0.5 bg-gray-100 rounded text-xs font-medium text-gray-700">{k}: {v}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
